export default class SectionHeaderElement {
    constructor(node) {
        this.node = node;
        Object.assign(this, node);
    }
}
